export default "__VITE_ASSET__0ea4ba7f__"